import { Component, EventEmitter, Output, AfterViewInit,ViewChild, ElementRef, HostListener } from '@angular/core';
import * as moment from 'moment';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { BillingService } from 'src/app/private/services/billing.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { FormControl } from '@angular/forms';
import * as XLSX from 'xlsx';
import { catchError, map, merge, startWith, switchMap, of as observableOf } from 'rxjs';

@Component({
  selector: 'app-billing-statement-table',
  templateUrl: './billing-statement-table.component.html',
  styleUrls: ['./billing-statement-table.component.scss']
})
export class BillingStatementTableComponent implements AfterViewInit {
  @ViewChild('scrollinfoContainer') scrollinfoContainer!: ElementRef;
  @Output() DateFilter: EventEmitter<any> = new EventEmitter();
  @Output() PaymentFilter: EventEmitter<any> = new EventEmitter();
  @Output() SearchFilter: EventEmitter<any> = new EventEmitter();
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    isMobileView = window.innerWidth <= 1024;
    scrollThumbWidth = 10;
    scrollThumbLeft = 0;
    mobileInfoVisible : any;
  initialLoad: boolean = true;
  isDataLoading: boolean = false;
  fileName = moment().format('YYYY-MM-DD') + '_collection_report.xlsx';
  actionButton: string = 'search';
  SearchInput: string = '';
  BillingDataList: any[] = [];
  totalCollection: any;
  cashCollection: any;
  debitCollection: any;
  creditCollection: any;
  upiCollection: any;
  _day: any = "Total"
  dateQuery = new FormControl();
  paymentType = new FormControl();
  searchQuery = new FormControl();
  FilterdateStart: any = new Date();
  Filterdateend: any = new Date();


  filtersObject:any = {};
  topBarTitle = "OPD Reports";
  exportColumns:any = [];


  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  current_id_hover:any;
  hoveredRow: any;
  topPosition: any;
  leftPosition: any;
  exportArrayData:any = [];

  displayedColumns: string[] = ["s_no","info","patient","uhid","opd_no","invoice_no","invoice_date","payment_status","payment_method","paid_amount"];


  opdAnalytics: any = {}
  constructor(private toast: ToastrService, private api: BillingService, private localStorage: LocalStorageService) {}

  ngAfterViewInit() {
    this.loadData();
  }
  ngOnInit(): void { 
    this.updateScrollThumb();
    setTimeout(() => this.updateScrollThumb(), 100);
  }

  filterByDateRange() {
    if (!this.FilterdateStart || !this.Filterdateend) return;
    
    let start = moment(this.FilterdateStart).format('YYYY-MM-DD');
    let end = moment(this.Filterdateend).format('YYYY-MM-DD');
    
    if (start !== 'Invalid date' && end !== 'Invalid date') {
      let object = { startDate: start, endDate: end };
      this.DateFilter.emit(object);
      this.loadData();
    }
  }

  onPaymentTypeChange(event: any) {
    const paymentMethod = event.target.value;
    this.PaymentFilter.emit(paymentMethod ? { payment_method: paymentMethod } : '');
    this.loadData();
  }

  getFilterValue() {
    if (!this.SearchInput.trim()) {
      this.toast.error('Enter Name, Email, Mobile, PId, or UHID');
      return;
    }
    
    let filterObject = {
      fname: this.SearchInput,
      lname: this.SearchInput,
      mobile: this.SearchInput,
      email: this.SearchInput,
      pId: this.SearchInput,
      old_patient_record_number: this.SearchInput,
    };
    
    this.SearchFilter.emit(filterObject);
    this.actionButton = 'reset';
    this.loadData();
  }

  resetFilter() {
    this.actionButton = 'search';
    this.SearchInput = '';
    this.SearchFilter.emit('');
    this.PaymentFilter.emit('');
    this.loadData();
  }

  resetDatePicker() {
    this.FilterdateStart = new Date();
    this.Filterdateend = new Date();
    this.filterByDateRange();
  }

  loadData() {

try{
     this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
     merge(this.dateQuery.valueChanges,this.searchQuery.valueChanges, this.sort.sortChange, this.paginator.page).pipe(startWith({}),
     switchMap(()=>{
      this.isDataLoading = true;
      let param = {
        where:{hospital_id:this.localStorage.getHospitalId(),center_id:this.localStorage.getCenterId()},
        filter:this.searchQuery.value,
        custom_filter:this.filtersObject,
        page:(this.paginator.pageIndex *  this.paginator.pageSize),
        limit:this.paginator.pageSize,
        // order:[{col:'appointment_date',dir:"desc"}],
      }
      if(this.dateQuery.value){param = {...param,...this.dateQuery.value}}
      if(this.localStorage.checkFullAccessForTableList(this.localStorage.getRole())){
        param = param
      }else{
        param = {...param,...{user_id:this.localStorage.getUserId()}}
      }
     
      //console.log(this.localStorage.getRole())
      return  this.api.getBillingData(param)
      .pipe(catchError(() => observableOf(null)));
     }),map((response:any)=>{
      this.initialLoad = false;
      if (response === null) {
        return [];
      }
      this.totalRows = response.count;
      return response
     })
     ).subscribe({
      next:(data:any) =>{
     // console.log(data)
      this.initialLoad = false;
            this.isDataLoading = false;
      this.exportArrayData = data;
      this.dataSource = new MatTableDataSource<any>(data);
      const collections = data.reduce((acc:any, item:any) => {
        const amount = Number(item.amount);
        acc.total += amount;
      
        if (item.payment_method === "CASH") acc.cash += amount;
        else if (item.payment_method === "Debit Card") acc.debit += amount;
        else if (item.payment_method === "Credit Card") acc.credit += amount;
        else if (item.payment_method === "UPI/QR" || item.payment_method === "UPI") acc.upi += amount;
      
        return acc;
      }, { total: 0, cash: 0, debit: 0, credit: 0, upi: 0 });
      
      this.totalCollection = collections.total;
      this.cashCollection = collections.cash;
      this.debitCollection = collections.debit;
      this.creditCollection = collections.credit;
      this.upiCollection = collections.upi;
      // removing doctor for hospital wise
      },
      error:(e)=>{
        this.initialLoad = false;
            this.isDataLoading = false;
       console.error(e)
      },
      complete:()=>{
       this.initialLoad = false;
      }
     })
    }
    catch(e){
      this.initialLoad = false;
     console.error(e)
    }





    // try {
    //   merge(this.dateQuery.valueChanges, this.paymentType.valueChanges, this.searchQuery.valueChanges)
    //     .pipe(
    //       startWith({}),
    //       switchMap(() => {
    //         let param: any = { where: { hospital_id: this.localStorage.getHospitalId(), center_id: this.localStorage.getCenterId() } };
            
    //         if (this.dateQuery.value) param = { ...param, ...this.dateQuery.value };
    //         if (this.paymentType.value) param.where = { ...param.where, payment_method: this.paymentType.value };
    //         if (this.searchQuery.value) param.where = { ...param.where, ...this.searchQuery.value };
            
    //         return this.api.getBillingData(param).pipe(catchError(() => observableOf([])));
    //       }),
    //       map((response: any) => {
    //         if (!response) return [];
    //         this.totalCollection = response.reduce((acc: number, item: any) => acc + Number(item.amount), 0);
    //         return response;
    //       })
    //     )
    //     .subscribe({
    //       next: (data) => (this.BillingDataList = data),
    //       error: (e) => console.error(e),
    //     });
    // } catch (e) {
    //   console.error(e);
    // }
  }

  export(header:any): void {
    const heading = [['S.No', 'OPD No', 'Invoice No', 'Invoice Date', 'Payment Status', 'Payment Method', 'Paid Amount']];
    const data = this.BillingDataList.map((item, index) => [index + 1, item.opd_no, item.receipt_no, item.billing_date, item.status, item.payment_method, item.amount]);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(heading);
    XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }


  searchFilter(query:any){
    this.searchQuery.setValue(query);
  }

  customSearchFilter(event:any){
    this.filtersObject = event;
    this.loadData();
  }

  dateFilter(event:any){
   this.dateQuery.setValue(event)
  }

  showFilterData(event:any){
    if(event){
    
    }
  }

  showInfo(row:any,event:any)
  {
    // this.hoveredRow = row;
    this.topPosition =  event.clientY;
    this.leftPosition = event.clientX;
    this.current_id_hover = row.id
  }

  onMouseMove(row:any,event: MouseEvent): void {
    this.current_id_hover =  row.id;
  }

  hideInfo()
  {
    this.current_id_hover = "";
    this.mobileInfoVisible = null;
  }
  toggleMobileInfo(element: any){
    this.mobileInfoVisible = this.mobileInfoVisible === element.id ? null : element.id;
      if (window.innerWidth > 1024) {
        this.current_id_hover = "";
      }
  }
  @HostListener('window:resize', ['$event'])
      onResize(event: Event) {
      if (window.innerWidth > 1024) {
        this.mobileInfoVisible = false;
        this.current_id_hover = "";
        
    this.isMobileView = window.innerWidth <= 1024;
      }
    }
  handleShowInfo(element: any, event: any){
    this.showInfo(element, event);
    this.toggleMobileInfo(element);
  }

scrollLeft()  {
    const container = this.scrollinfoContainer.nativeElement;
    container.scrollBy({ left: -150, behavior: 'smooth' });
  }
  
  scrollRight() {
    const container = this.scrollinfoContainer.nativeElement;
    container.scrollBy({ left: 150, behavior: 'smooth' });
  }
handleScrollLeft() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: -150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

handleScrollRight() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: 150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

updateScrollThumb() {
  if (!this.scrollContainer) return;

  const container = this.scrollContainer.nativeElement;
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;
  const scrollLeft = container.scrollLeft;

  if (scrollWidth > clientWidth) {
    this.scrollThumbWidth = Math.max(10, Math.min(100, (clientWidth / scrollWidth) * 100));
    const maxScrollLeft = scrollWidth - clientWidth;
    const scrollPercentage = (scrollLeft / maxScrollLeft) * 100;
    this.scrollThumbLeft = (scrollPercentage * (100 - this.scrollThumbWidth)) / 100;
    this.scrollThumbLeft = Math.max(0, Math.min(100 - this.scrollThumbWidth, this.scrollThumbLeft));
  } else {
    this.scrollThumbWidth = 100;
    this.scrollThumbLeft = 0;
  }
}

}
